import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@domainstack/ui/skeleton";
import { cn } from "@domainstack/ui/utils";
export function KeyValueSkeleton(t0) {
  const $ = _c(25);
  const {
    label,
    withLeading: t1,
    withTrailing: t2,
    withSuffix: t3,
    widthClass: t4,
    trailingClassName
  } = t0;
  const withLeading = t1 === undefined ? false : t1;
  const withTrailing = t2 === undefined ? false : t2;
  const withSuffix = t3 === undefined ? false : t3;
  const widthClass = t4 === undefined ? "w-2/3" : t4;
  let t5;
  if ($[0] !== label) {
    t5 = label ? <div className="pt-1 text-[10px] leading-none tracking-[0.08em] text-foreground/75 uppercase dark:text-foreground/80">{label}</div> : null;
    $[0] = label;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== withLeading) {
    t6 = withLeading && <Skeleton className="size-4 shrink-0 rounded" />;
    $[2] = withLeading;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== widthClass) {
    t7 = cn("h-4 shrink-0", widthClass);
    $[4] = widthClass;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t7) {
    t8 = <Skeleton className={t7} />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== withSuffix) {
    t9 = withSuffix && <Skeleton className="h-3 w-15 shrink-0" />;
    $[8] = withSuffix;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t6 || $[11] !== t8 || $[12] !== t9) {
    t10 = <div className="inline-flex h-[1lh] min-w-0 items-center gap-1.5 text-[13px]">{t6}{t8}{t9}</div>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5) {
    t11 = <div className="flex min-w-0 flex-col space-y-1.5">{t5}{t10}</div>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== trailingClassName || $[18] !== withTrailing) {
    t12 = withTrailing && <Skeleton className={cn("rounded-md", trailingClassName ?? "-mr-1 size-8")} />;
    $[17] = trailingClassName;
    $[18] = withTrailing;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <div className="flex shrink-0 items-center gap-2">{t12}</div>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t11 || $[23] !== t13) {
    t14 = <div className="flex h-16 min-w-0 items-center justify-between gap-4 rounded-lg border border-border bg-background/60 px-4 py-3 backdrop-blur-lg">{t11}{t13}</div>;
    $[22] = t11;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}
export function KeyValueSkeletonList(t0) {
  const $ = _c(12);
  const {
    count,
    widthClass: t1,
    withLeading: t2,
    withTrailing: t3,
    withSuffix: t4,
    trailingClassName,
    keyPrefix: t5
  } = t0;
  const widthClass = t1 === undefined ? "w-[100px]" : t1;
  const withLeading = t2 === undefined ? false : t2;
  const withTrailing = t3 === undefined ? false : t3;
  const withSuffix = t4 === undefined ? false : t4;
  const keyPrefix = t5 === undefined ? "kv-skel" : t5;
  let t6;
  if ($[0] !== count || $[1] !== keyPrefix) {
    let t7;
    if ($[3] !== keyPrefix) {
      t7 = (_, i) => `${keyPrefix}-${i + 1}`;
      $[3] = keyPrefix;
      $[4] = t7;
    } else {
      t7 = $[4];
    }
    t6 = Array.from({
      length: count
    }, t7);
    $[0] = count;
    $[1] = keyPrefix;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[5] !== t6 || $[6] !== trailingClassName || $[7] !== widthClass || $[8] !== withLeading || $[9] !== withSuffix || $[10] !== withTrailing) {
    t7 = <>{t6.map(key => <KeyValueSkeleton key={key} widthClass={widthClass} withLeading={withLeading} withTrailing={withTrailing} withSuffix={withSuffix} trailingClassName={trailingClassName} />)}</>;
    $[5] = t6;
    $[6] = trailingClassName;
    $[7] = widthClass;
    $[8] = withLeading;
    $[9] = withSuffix;
    $[10] = withTrailing;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}